import { createTheme } from '@mui/material/styles';

// Brand colors
const BRAND_YELLOW = '#FBBC04';
const BRAND_YELLOW_LIGHT = '#FFF8E1';
const BRAND_YELLOW_HOVER = '#F9A825';

const theme = createTheme({
  palette: {
    primary: {
      main: BRAND_YELLOW,
      light: BRAND_YELLOW_LIGHT,
      dark: BRAND_YELLOW_HOVER,
      contrastText: '#2D2D2D',
    },
    secondary: {
      main: '#344767',
      light: '#7b809a',
      dark: '#1a2035',
    },
    success: {
      main: '#4CAF50',
      light: '#E8F5E9',
    },
    warning: {
      main: '#FF9800',
      light: '#FFF3E0',
    },
    error: {
      main: '#F44336',
      light: '#FFEBEE',
    },
    info: {
      main: '#2196F3',
      light: '#E3F2FD',
    },
    background: {
      default: '#f0f2f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#344767',
      secondary: '#7b809a',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
        containedPrimary: {
          background: `linear-gradient(135deg, ${BRAND_YELLOW} 0%, ${BRAND_YELLOW_HOVER} 100%)`,
          '&:hover': {
            background: `linear-gradient(135deg, ${BRAND_YELLOW_HOVER} 0%, ${BRAND_YELLOW} 100%)`,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
